import { Container } from "react-bootstrap";
import Card from "../../common/components/Card";
import NotesTable from "../../common/components/NotesTable";
import { useEpcrEditorNotes } from "./EpcrContext";
import PropTypes from 'prop-types';
import useClientConfig from "../../common/hooks/clientConfigHook";

const EpcrNotes = ({ disabled = false }) => {
    const clientConfig = useClientConfig();
    const { notes, addNote, strikeNote } = useEpcrEditorNotes();
    
    return <Container fluid>
            <Card><div style={{height: 'calc(100dvh - 275px)'}}><NotesTable notes={notes} tz={clientConfig.tz} disabled={disabled} onStrike={strikeNote} onAdd={addNote}></NotesTable></div></Card>
        </Container>
}

EpcrNotes.propTypes = {
    disabled: PropTypes.bool
}

export default EpcrNotes;